import React, { Component } from 'react';
import { EconomicalScoreTrackerPlayer } from '../stateless/eco-score-player';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';
import { players } from '../../constants/images';
import arrow from '../../../assets/images/svgs/icons/arrow_down.svg';

/**
 * @class EconomicalScoreTracker
 *
 * @description
 * Class for.
 *
 * @example
 * <EconomicalScoreTracker />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : { options: [] };
		let activeStep = state.step.activeStep && state.setup[state.step.activeStep.ref][state.step.activeStep.id];
		if (activeStep && (activeStep.male || activeStep.female)) {
			activeStep = activeStep.male || activeStep.female;
		}
		return {
			step: state.step,
			results: state.results,
			activePlayers: (activeStep && activeStep.windows && activeStep.windows[state.currentWindow.index]) && activeStep.windows[state.currentWindow.index].players,
			avatarOptions: avatar && avatar.options ? avatar.options : null
		}
	}
)
export default class EconomicalScoreTrackerInputReturn extends Component {

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { currentValue, window, unit, activePlayers } = this.props;

		const max = (window.current && window.current.answers && window.current.answers.range) ? window.current.answers.range.max : null;
		const playerAvatar = buildAvatar(this.props, false);

		return (max && activePlayers) ? (
			<div className={'eco-score-tracker__standard'}>
				<EconomicalScoreTrackerPlayer score={(currentValue) * -1}
																			unit={unit}
																			imgSrc={playerAvatar} />

				<img className={'eco-arrow'}
						 src={arrow} />

				<EconomicalScoreTrackerPlayer score={currentValue * 3 || 0}
																			unit={unit}
																			imgSrc={players[activePlayers[1]]} />

				<img className={'eco-arrow'}
						 src={arrow} />

				<div className={'eco-score-tracker__standard__group-wrap'}>

					<EconomicalScoreTrackerPlayer score={currentValue > 0 ? '?' : 0}
																				imgSrc={playerAvatar} />
					<EconomicalScoreTrackerPlayer score={currentValue > 0 ? '?' : 0}
																				imgSrc={players[activePlayers[1]]} />
				</div>
			</div>
		) : null;
	}
}

